import { jsx as t } from "react/jsx-runtime";
import { forwardRef as m, useCallback as d } from "react";
import { CreditCardFrontIcon as k } from "../../../icons/componentIcons.mjs";
import { MaskInput as p } from "../../MaskInput/MaskInput.mjs";
import "../../MaskInput/MaskBase.mjs";
var u = /* @__PURE__ */ ((r) => (r.AE = "American Express", r.Visa = "Visa", r.MC = "Master Card", r.Discover = "Discover", r.UnknownCard = "Unknown Card", r))(u || {});
const f = m((r, s) => {
  const { onChange: e, ...o } = r, i = d(
    (n, c) => {
      let a;
      switch (n.value.charAt(0)) {
        case "3":
          a = "American Express";
          break;
        case "4":
          a = "Visa";
          break;
        case "5":
          a = "Master Card";
          break;
        case "6":
          a = "Discover";
          break;
        default:
          a = "Unknown Card";
          break;
      }
      e && e({ ...n, ccType: a }, c);
    },
    [e]
  );
  return /* @__PURE__ */ t(
    p,
    {
      ref: s,
      format: "#### #### #### ####",
      mask: "",
      onChange: i,
      ...o,
      inputRightElement: /* @__PURE__ */ t(k, { variant: "light", className: "ccinput-right-icon" })
    }
  );
});
f.displayName = "CCNumberInput";
export {
  f as CCNumberInput,
  u as CCType
};
